import { map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type ChildrenPreferencesMultiSelectInput_query$key } from '@/__generated__/ChildrenPreferencesMultiSelectInput_query.graphql'
import { MultiSelectInput, type MultiSelectInputProps, type MultiSelectInputRef, type SelectOption } from '@/components'

export type ChildrenPreferencesMultiSelectInputProps = Omit<MultiSelectInputProps, 'options' | 'ref'> & {
  queryRef: ChildrenPreferencesMultiSelectInput_query$key | null | undefined
}

export const ChildrenPreferencesMultiSelectInput = forwardRef<
  MultiSelectInputRef,
  ChildrenPreferencesMultiSelectInputProps
>(({ queryRef, ...props }, ref) => {
  const queryData = useFragment(
    graphql`
      fragment ChildrenPreferencesMultiSelectInput_query on Query {
        childrenPreferences(orderBy: [SEQUENCE_ASC]) {
          nodes {
            name
            rowId
          }
        }
      }
    `,
    queryRef
  )

  return (
    <MultiSelectInput
      options={useMemo<SelectOption[]>(
        () =>
          map(queryData?.childrenPreferences?.nodes, (childrenPreference) => ({
            label: childrenPreference!.name,
            value: childrenPreference!.rowId
          })),
        [queryData?.childrenPreferences?.nodes]
      )}
      ref={ref}
      {...props}
    />
  )
})

ChildrenPreferencesMultiSelectInput.displayName = 'ChildrenPreferencesMultiSelectInput'
